import { useState } from "react";
import { Loader2 } from "lucide-react";

export const STATUSES = [
  { key: "new", label: "Nuova", dot: "bg-amber-400", chip: "border-amber-400/40 bg-amber-400/10 text-amber-300" },
  { key: "contacted", label: "Contattata", dot: "bg-[var(--cyan)]", chip: "border-[var(--cyan)]/40 bg-[var(--cyan)]/10 text-[var(--cyan)]" },
  { key: "closed", label: "Chiusa", dot: "bg-emerald-400", chip: "border-emerald-400/40 bg-emerald-400/10 text-emerald-300" },
];
export const statusMeta = (key) => STATUSES.find((s) => s.key === key) ?? STATUSES[0];

export const StatusBadge = ({ status, id }) => {
  const m = statusMeta(status);
  return (
    <span data-testid={`quote-status-badge-${id}`} className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 font-mono text-[11px] uppercase tracking-[0.18em] ${m.chip}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${m.dot}`} />{m.label}
    </span>
  );
};

export const StatusControl = ({ id, status, onChange }) => {
  const [busy, setBusy] = useState(false);
  const pick = async (key) => {
    if (key === status || busy) return;
    setBusy(true);
    try { await onChange(id, key); } finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-1 rounded-full border border-white/10 bg-white/[0.03] p-1" data-testid={`quote-status-control-${id}`} role="radiogroup" aria-label="Stato richiesta">
      {STATUSES.map((s) => {
        const active = s.key === status;
        return (
          <button key={s.key} type="button" role="radio" aria-checked={active} disabled={busy} onClick={() => pick(s.key)}
            data-testid={`quote-status-${s.key}-${id}`}
            className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-[background-color,color,transform] duration-200 active:scale-95 ${active ? "bg-white text-[#060B18]" : "text-slate-400 hover:bg-white/10 hover:text-white"}`}>
            {s.label}
          </button>
        );
      })}
      {busy && <Loader2 className="ml-1 h-3.5 w-3.5 animate-spin text-slate-400" />}
    </div>
  );
};

export const StatusFilter = ({ value, counts, onChange }) => (
  <div className="flex flex-wrap gap-2" data-testid="quote-status-filter">
    {[{ key: "all", label: "Tutte" }, ...STATUSES].map((s) => {
      const active = value === s.key;
      return (
        <button key={s.key} type="button" onClick={() => onChange(s.key)} data-testid={`quote-filter-${s.key}`}
          className={`flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold transition-[background-color,color,border-color] duration-200 ${active ? "border-white bg-white text-[#060B18]" : "border-white/10 text-slate-300 hover:border-white/30 hover:text-white"}`}>
          {s.dot && <span className={`h-2 w-2 rounded-full ${s.dot}`} />}
          {s.label}
          <span className={`font-mono text-xs ${active ? "text-[#060B18]/60" : "text-slate-500"}`} data-testid={`quote-count-${s.key}`}>{counts[s.key] ?? 0}</span>
        </button>
      );
    })}
  </div>
);
